export const CAPTURE_MONTHLY_PLAN = {
  price: process.env.PRICE_8,
  priceAmount: 8,
  id: 'capture_monthly',
  title: 'Lazy Capture',
  subTitle: 'Capture at speed of thought',
  recurrence: 'every month',
  description: 'Quick capture from anywhere with unlimited notes & tasks',
  features: [
    { text: 'Lazy Capture', watchUrl: 'https://www.youtube.com/watch?v=ZoPw4xV9TWQ' },
    { text: 'Networked note-taking' },
    { text: 'Unlimited notes & file uploads' },
    { text: 'Offline mode for notes' },
    { text: 'Kindle highlights Sync' },
    { text: 'Universal clipper' },
    { text: 'Capture to Notion', watchUrl: 'https://www.youtube.com/watch?v=IfIULhx-CN4' },
    { text: 'iOS capture' },
  ],
  includes: 'Includes',
}

export const CAPTURE_YEARLY_PLAN = {
  price: process.env.PRICE_72,
  priceAmount: 6,
  id: 'capture_yearly',
  title: 'Lazy Capture',
  subTitle: 'Capture at speed of thought',
  recurrence: 'every year',
  description: 'Save $24/year. Best value for focused note-taking.',
  features: [
    { text: 'Lazy Capture', watchUrl: 'https://www.youtube.com/watch?v=ZoPw4xV9TWQ' },
    { text: 'Networked note-taking' },
    { text: 'Unlimited notes & file uploads' },
    { text: 'Offline mode for notes' },
    { text: 'Kindle highlights Sync' },
    { text: 'Universal clipper' },
    { text: 'Capture to Notion', watchUrl: 'https://www.youtube.com/watch?v=IfIULhx-CN4' },
    { text: 'iOS capture' },
  ],
  includes: 'Includes',
}

export const AI_MONTHLY_PLAN = {
  price: process.env.PRICE_15,
  priceAmount: 15,
  id: 'ai_monthly',
  title: 'Lazy AI',
  subTitle: 'Leverage AI anywhere',
  recurrence: 'every month',
  description: 'Pay monthly without missing any feature, including Lazy AI',
  features: [
    { text: 'Lazy AI', watchUrl: 'https://www.youtube.com/watch?v=ApKA7eOM8bA' },
    { text: 'Context-aware answers from captures' },
    { text: 'Chat with knowledge base', watchUrl: 'https://www.youtube.com/watch?v=y8-jMskj-9w' },
    { text: 'Priority access to new AI features' },
  ],
  popular: true,
  includes: 'Everything in Lazy Capture',
}

export const AI_YEARLY_PLAN = {
  price: process.env.PRICE_150,
  priceAmount: 12.5,
  id: 'ai_yearly',
  title: 'Lazy AI',
  subTitle: 'Leverage AI anywhere',
  recurrence: 'every year',
  description: 'Save $30. Best value for deep work and long-term flow.',
  features: [
    { text: 'Lazy AI', watchUrl: 'https://www.youtube.com/watch?v=ApKA7eOM8bA' },
    { text: 'Context-aware answers from captures' },
    { text: 'Chat with knowledge base', watchUrl: 'https://www.youtube.com/watch?v=y8-jMskj-9w' },
    { text: 'Priority access to new AI features' },
  ],
  popular: true,
  includes: 'Everything in Lazy Capture',
}

export const PLANS = {
  '8': CAPTURE_MONTHLY_PLAN,
  '72': CAPTURE_YEARLY_PLAN,
  '15': AI_MONTHLY_PLAN,
  '150': AI_YEARLY_PLAN,
}

export const LEGACY_PLANS = {
  '15': AI_MONTHLY_PLAN,
  '150': AI_YEARLY_PLAN,
}
